import React, {useState} from "react";
import SearchTicketModal from "../SearchTicketModal/SearchTicketModal";
import Table from "../Table/Table";
import "./ClientsTableView.css";

const ClientsTableView = ({
                              title,
                              columns,
                              clientsInfo,
                              totalPages,
                              isLoading,
                              page,
                              setFilters,
                              setPage,
                              handleAdd,
                              disableAddButton = false,
                              onRowClick,
                          }: {
    title: string;
    columns: string[];
    clientsInfo: any[];
    totalPages: number;
    isLoading: boolean;
    page: number;
    setFilters: (filters: object) => void;
    setPage: (page: number) => void;
    handleAdd?: () => void;
    disableAddButton?: boolean;
    onRowClick?: (row: Record<string, any>) => void;
}) => {
    const [isSearchModalVisible, setSearchModalVisible] = useState(false);

    const handleResetClientsTable = () => {
        setFilters({});
        setPage(0);
    };

    const handleSearchModal = (uniqueCode: string) => {
        setFilters({uniqueCode});
    };

    return (
        <div className="clients-view-container">
            <div className="clients-view-header">
                <div className="clients-view-header-title">
                    <p>{title}</p>
                </div>
                {!disableAddButton && (
                    <span className="material-icons-outlined icon-unselected" onClick={handleAdd}>
                        add_box
                    </span>
                )}
                <span className="material-icons-outlined icon-unselected" onClick={() => setSearchModalVisible(true)}>
                    search
                </span>
                <span className="material-icons-outlined icon-unselected" onClick={handleResetClientsTable}>
                    restart_alt
                </span>
            </div>
            {isLoading ? (
                <div className="loading-overlay">
                    <div className="spinner"></div>
                    <div className="loading-message">Obteniendo información...</div>
                </div>
            ) : (
                <div className="clients-view-table">
                    <Table
                        columns={columns}
                        data={clientsInfo}
                        totalPages={totalPages}
                        currentPage={page}
                        setCurrentPage={setPage}
                        onRowClick={onRowClick}
                    />
                </div>
            )}
            <SearchTicketModal
                isVisible={isSearchModalVisible}
                onClose={() => setSearchModalVisible(false)}
                onSearch={handleSearchModal}
                placeholder="Clave de cliente"
            />
        </div>
    );
};

export default ClientsTableView;
